import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivate } from '@angular/router';

import { Store } from '@ngrx/store';

import { CartStatus } from '@fcom/dapi/interfaces';
import { snapshot } from '@fcom/rx';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { BookingAppState } from '@fcom/common/interfaces/booking/booking-state.interface';

import { cartStatus } from '../../../store/selectors';
import { BookingService } from '../../../services';

@Injectable()
export class PaxDetailsGuard implements CanActivate {
  constructor(
    private store$: Store<BookingAppState>,
    private bookingService: BookingService,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  canActivate() {
    if (isPlatformServer(this.platform)) {
      return true;
    }

    const canAccess: boolean = snapshot(this.store$.pipe(cartStatus())) !== CartStatus.INITIAL;

    if (!canAccess) {
      this.bookingService.setStep({ step: BOOKING_STEPS.FLIGHT_SELECTION });
    }

    return canAccess;
  }
}
